module.exports = __webpack_public_path__ + "img/source1.7f37213f.png";